/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react"
import { FormikProvider } from "formik"
// Components
import { MainLayout } from "views/components/layout/main"
import { ImageInput } from "views/components/molecules/input/image"
import FormRow from "views/components/atoms/layout/formRow"
import Card from "views/components/atoms/card"
import {
  FormikSelect,
  FormikTextarea,
} from "views/components/molecules/form/fieldControl"
import Button from "views/components/atoms/input/button"
import { RegistryLayout } from "views/components/layout/registry"
import FormikErrorControl from "views/components/molecules/form/formikErrorControl"
// Hooks
import { px, space } from "views/style"
import { useStampCardRegister } from "./hooks"
import { DatePicker } from "views/components/molecules/input/datepicker"
import { day } from "logics/utils/formatter"
export const StampCardRegister = () => {
  const { uploadedFileInfo, form, onCancel, couponOptions, companyName, date } =
    useStampCardRegister()
  return (
    <MainLayout>
      <FormikProvider value={form}>
        <RegistryLayout
          title="スタンプカード登録"
          aside={
            <>
              <Button type="button" variant="outlined" onClick={onCancel}>
                <>キャンセル</>
              </Button>
              <Button
                type="submit"
                css={css`
                  margin-left: ${space._4};
                `}
              >
                <>登録する</>
              </Button>
            </>
          }
          onSubmit={form?.handleSubmit}
        >
          <div
            css={css`
              display: flex;
              justify-content: space-between;
            `}
          >
            <div
              css={css`
                flex: 1 1 calc(50% - ${space._6});
              `}
            >
              <Card>
                <FormRow
                  label="フランチャイズ名"
                  content={<span>{companyName}</span>}
                />
                <FormRow
                  label="説明文"
                  content={<FormikTextarea name="description" />}
                  required={true}
                />
                <FormikErrorControl name="uploadedFileInfo">
                  {(errorMessage) => (
                    <ImageInput
                      {...uploadedFileInfo}
                      errorMessage={errorMessage}
                    />
                  )}
                </FormikErrorControl>
                <FormRow
                  label={"景品選択"}
                  content={
                    <FormikSelect
                      name="couponId"
                      dataSource={[
                        { value: "", label: "クーポンを選択してください" },
                        ...(couponOptions || []),
                      ]}
                    />
                  }
                  required={true}
                  doubleColumn={1}
                />
              </Card>
            </div>
            <div
              css={css`
                flex: 0 0 ${px._512};
                margin-left: ${space._8};
              `}
            >
              <Card>
                <FormRow
                  label="掲載期間"
                  content={
                    <div
                      css={css`
                        display: flex;
                        align-items: center;
                      `}
                    >
                      <DatePicker
                        name="from"
                        onChange={date.setFormDate}
                        value={
                          !!form?.values?.from
                            ? day(form?.values?.from?.toDateString())
                            : undefined
                        }
                      />
                      <span
                        css={css`
                          margin: 0 ${space._2};
                        `}
                      >
                        ～
                      </span>
                      <DatePicker
                        name="to"
                        onChange={date.setToDate}
                        value={
                          !!form?.values?.to
                            ? day(form?.values?.to?.toDateString())
                            : undefined
                        }
                      />
                    </div>
                  }
                />
              </Card>
            </div>
          </div>
        </RegistryLayout>
      </FormikProvider>
    </MainLayout>
  )
}
